import React, { useContext } from 'react';
import { string, func, number, shape } from 'prop-types';

import SmartbannerContext from '~screens/Commerce/contexts/SmartbannerContext/context';

import useSmartBanner from './hooks/useSmartBanner';
import styles from './styles.module.scss';
import { daysReminder, daysHidden } from './constants';

const SmartBanner = ({ appsLinks, title, button, daysHidden, daysReminder, onClose, onInstall }) => {
  const { setIsSmartbannerActive } = useContext(SmartbannerContext);
  const { ableToShow, install, appLink, close } = useSmartBanner({
    appsLinks,
    daysHidden,
    daysReminder,
    onClose,
    onInstall,
    setIsSmartbannerActive
  });
  return (
    <>
      {ableToShow && (
        <div className={styles.smartBanner}>
          <div className={styles.leftInfo}>
            <button
              data-testid="close-smartbanner"
              type="button"
              className={styles.smartBannerClose}
              aria-label="close"
              onClick={close}>
              &times;
            </button>
            <div className={styles.smartBannerTitle}>{title}</div>
          </div>
          <button
            id="install-app-smartbanner"
            data-applink={appLink}
            type="button"
            onClick={install}
            className={styles.smartBannerButton}>
            {button}
          </button>
        </div>
      )}
    </>
  );
};

SmartBanner.propTypes = {
  appsLinks: shape({
    appStore: string,
    playStore: string
  }),
  button: string,
  daysHidden: number,
  daysReminder: number,
  title: string,
  onClose: func,
  onInstall: func
};

SmartBanner.defaultProps = {
  appsLinks: [],
  button: 'View',
  daysHidden: daysHidden,
  daysReminder: daysReminder,
  title: ''
};

export default SmartBanner;
